// src/components/ThemeProvider.js
import React, { createContext, useContext, useEffect, useState } from 'react';
import { fetchThemeSettings } from '../utils/api';

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState({ primaryColor: '#173D2D', secondaryColor: '#41584A' }); // Fallback

  useEffect(() => {
    const loadTheme = async () => {
      try {
        const settings = await fetchThemeSettings();
        setTheme(settings);
        // Dynamically update CSS variable for Tailwind
        // In useEffect, after fetching settings:
        document.documentElement.style.setProperty('--primary', settings.primaryColor || '#173D2D');
        document.documentElement.style.setProperty('--secondary', settings.secondaryColor || '#41584A');
        document.documentElement.style.setProperty('--bg-cream', '#F7F4EA');
        document.documentElement.style.setProperty('--eco-green', '#6F8F43');
      } catch (error) {
        console.error('Failed to load theme:', error);
      }
    };
    loadTheme();
  }, []);

  return (
    <ThemeContext.Provider value={theme}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}

export default ThemeProvider;